import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { queryRelevanceTestRuns, QUERY_KEY } from 'src/queries/queryRelevanceTestRuns';

type TestRuns = Models.PageResult<Models.IngestConfigApi.RelevanceTests.RelevanceTestRun>;
type QueryKey = App.RelevanceTestRuns.QueryKey;

export const useQueryRelevanceTestRuns = (
    accessToken: string | undefined | false,
    search: App.RelevanceTestRuns.PagedSearch,
    options?: UseQueryOptions<TestRuns, Error, TestRuns, QueryKey>,
): UseQueryResult<TestRuns, Error> => useQuery<TestRuns, Error, TestRuns, QueryKey>(
    [QUERY_KEY, accessToken, search],
    queryRelevanceTestRuns,
    options,
);
